import React from 'react';
import  { Link, Redirect } from 'react-router-dom'
import { connect } from "react-redux";
import { Form, Button } from 'react-bootstrap';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { authSet } from "../../actions";


const mapStateToProps = (state) => ({
    uType: state.auth.uType
});

const mapDispatchToProps = (dispatch) => ({
    authSet: (payload) => dispatch(authSet(payload)),
});

const Login = ({ uType, authSet }) => {
    let rfUn = React.createRef();
    let rfPw = React.createRef();

    const loginKeyAct = (ev) => {
        if (ev.keyCode == 13) {
            loginAct();            
        }
    };

    const loginAct = () => {
        const lin = {
            un: rfUn.current.value,
            pw: rfPw.current.value,
        };
        authSet(lin);        
    };

    let lgP = null;

    if (uType != 'admin') {
        const lgForm = (<Form style={{ 'marginLeft': '0%' }} onSubmit={ loginAct }>
            <Form.Group>
                <Form.Label>Korisnicko ime</Form.Label>
                <Form.Control type="text" ref={rfUn} defaultValue={''} onKeyUp={ loginKeyAct } />
            </Form.Group>
            <Form.Group style={{ marginTop: '1em' }}>
                <Form.Label>Lozinka</Form.Label>
                <Form.Control type="password" ref={rfPw} onKeyUp={ loginKeyAct } />
            </Form.Group>
            <Button variant="primary" type="button" onClick={loginAct} style={{ marginTop: '1em' }}>
            OK
            </Button>
        </Form>);
        lgP = <Container>
            <Row style={{ 'marginTop': '2em', textAlign: 'center' }}>
                <Col xs={12} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
                    { lgForm }
                </Col>
            </Row>
        </Container>
    } else {
        lgP = <Redirect to="/admin-dashboard" />    
    }

    return lgP;

}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
